import React from 'react';
import cn from 'classnames';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import { TypographyAllProps } from 'globals/types';
import FsCaption from 'ui-elements/typography/FsCaption';

export const Caption = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      color: palette.grey[400],
      marginBottom: spacing(2),
      width: '100%',
      [breakpoints.up('lg')]: {
        width: 'auto',
        marginBottom: 0,
        marginRight: spacing(1),
      },
    },
  })
)((props: TypographyAllProps) => <FsCaption component="span" {...props} />);

export const FiltersBox = withStyles(({ spacing }) => ({
  root: {
    flexWrap: 'wrap',
    marginBottom: spacing(2),
  },
}))((props: BoxProps) => {
  return <Box display="flex" alignItems="center" {...props} />;
});

interface SectionBoxProps extends BoxProps {
  isLast?: boolean;
}

export const SectionBox = withStyles(({ breakpoints, spacing }: Theme) => ({
  root: {
    width: '100%',
    marginBottom: spacing(2),
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    [breakpoints.up('lg')]: {
      flexWrap: 'nowrap',
      width: 'auto',
      marginBottom: 0,
    },
    '&.isLast': {
      marginBottom: 0,
    },
  },
}))(({ isLast = false, ...otherProps }: SectionBoxProps) => (
  <Box {...otherProps} className={cn({ isLast })} />
));
